// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { List } from 'immutable';
import { getVerificationResult } from '@tcp/core/src/components/common/organisms/AddressVerification/container/AddressVerification.selectors';
import { resetVerifyAddress } from '@tcp/core/src/components/common/organisms/AddressVerification/container/AddressVerification.actions';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import AddressBookReducer from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.reducer';
import AddressBookSaga from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.saga';
import AddEditAddressSaga from '@tcp/core/src/components/common/organisms/AddEditAddress/container/AddEditAddress.saga';
import DeleteAddressSaga from '@tcp/core/src/components/features/account/AddressBook/container/DeleteAddress.saga';
import AddEditAddressReducer from '@tcp/core/src/components/common/organisms/AddEditAddress/container/AddEditAddress.reducer';
import { SetDefaultShippingAddressSaga } from '@tcp/core/src/components/features/account/AddressBook/container/DefaultShippingAddress.saga';
import {
  getAddressList,
  deleteAddress,
  setDeleteModalMountedState,
  setAddressBookNotification,
  clearErrorState,
} from './AddressBook.actions';

import AddressView from '../views/AddressView';
import {
  getAddressListState,
  getAddressListFetchingState,
  showUpdatedNotificationState,
  deleteModalOpenState,
  showUpdatedNotificationOnModalState,
} from './AddressBook.selectors';
import { setDefaultShippingAddressRequest } from './DefaultShippingAddress.actions';
import {
  getIsInternationalPhoneNumber,
  getNewGlobalErrorMessage,
} from '../../../../../reduxStore/selectors/session.selectors';
import GlobalErrorComponentReducer from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.reducer';
import {
  hideError,
  setGlobalError,
  setModalError,
} from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import AddressBookLabels, { ACCOUNT_LABELS } from '../views/AddressBook.labels';
import { getErrorModalVisibleState } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.selectors';

export class AddressBookContainer extends React.Component {
  static propTypes = {
    getAddressListAction: PropTypes.func.isRequired,
    clearAddressBookNotification: PropTypes.func.isRequired,
    addressList: PropTypes.shape([]).isRequired,
    isFetching: PropTypes.bool.isRequired,
    onDefaultShippingAddressClick: PropTypes.func.isRequired,
    showUpdatedNotification: PropTypes.bool.isRequired,
    onDeleteAddress: PropTypes.func.isRequired,
    deleteModalMountedState: PropTypes.func.isRequired,
    setDeleteModalMountState: PropTypes.func.isRequired,
    showUpdatedNotificationOnModal: PropTypes.bool.isRequired,
    labels: PropTypes.shape({}).isRequired,
    verificationResult: PropTypes.shape({}).isRequired,
    clearNotificationError: PropTypes.string.isRequired,
    resetVerifyAddressAction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AddressBookLabels);
    this.common = this.accountLabels.common;
  }

  componentDidMount() {
    const { getAddressListAction } = this.props;
    getAddressListAction();
  }

  componentDidUpdate() {
    const {
      setGlobalErrorAction,
      showUpdatedNotification,
      showUpdatedNotificationOnModal,
      isErrorModalVisibleState,
      clearAddressBookNotification,
      setModalErrorAction,
      newGlobalErrorMessageEnabled,
    } = this.props;
    if (newGlobalErrorMessageEnabled) {
      if (showUpdatedNotification && !showUpdatedNotificationOnModal && !isErrorModalVisibleState) {
        clearAddressBookNotification();
        const errorMsg =
          showUpdatedNotification === 'success'
            ? renderLabel(this.common?.lbl_common_successMessage, 'lbl_common_successMessage')
            : renderLabel(this.common?.lbl_common_errorMessage, 'lbl_common_errorMessage');
        setGlobalErrorAction({ message: errorMsg, type: showUpdatedNotification });
      }
      if (showUpdatedNotificationOnModal && isErrorModalVisibleState) {
        setModalErrorAction({
          message: renderLabel(this.common?.lbl_common_errorMessage, 'lbl_common_errorMessage'),
          type: showUpdatedNotificationOnModal,
        });
      }
    }
  }

  componentWillUnmount() {
    const { clearAddressBookNotification, hideErrorAction } = this.props;
    clearAddressBookNotification();
    hideErrorAction();
  }

  render() {
    const {
      addressList,
      isFetching,
      onDefaultShippingAddressClick,
      showUpdatedNotification,
      onDeleteAddress,
      deleteModalMountedState,
      setDeleteModalMountState,
      showUpdatedNotificationOnModal,
      labels,
      verificationResult,
      clearNotificationError,
      resetVerifyAddressAction,
      isInternationalPhoneNumberEnabled,
      newGlobalErrorMessageEnabled,
      isErrorModalVisibleState,
    } = this.props;
    function filterAddresses() {
      return addressList?.filter(
        (address) => address?.countryCode === 'US' || address?.countryCode === 'CA'
      );
    }

    const filteredAddressList = filterAddresses();

    if (List.isList(filteredAddressList)) {
      return (
        <AddressView
          addresses={filteredAddressList}
          isFetching={isFetching}
          labels={labels}
          onDefaultShippingAddressClick={onDefaultShippingAddressClick}
          showUpdatedNotification={showUpdatedNotification}
          onDeleteAddress={onDeleteAddress}
          deleteModalMountedState={deleteModalMountedState}
          clearNotificationError={clearNotificationError}
          setDeleteModalMountState={setDeleteModalMountState}
          showUpdatedNotificationOnModal={showUpdatedNotificationOnModal}
          verificationResult={verificationResult}
          resetVerifyAddress={resetVerifyAddressAction}
          isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
          newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
          isErrorModalVisibleState={isErrorModalVisibleState}
        />
      );
    }
    return null;
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getAddressListAction: (payload) => {
      dispatch(getAddressList(payload));
    },
    onDefaultShippingAddressClick: (payload) => {
      dispatch(setDefaultShippingAddressRequest(payload));
    },
    onDeleteAddress: (payload) => {
      dispatch(deleteAddress(payload));
    },
    setDeleteModalMountState: (payload) => {
      dispatch(setDeleteModalMountedState(payload));
    },
    clearAddressBookNotification: () => {
      dispatch(
        setAddressBookNotification({
          status: '',
        })
      );
    },
    clearNotificationError: () => {
      dispatch(clearErrorState());
    },
    resetVerifyAddressAction: () => {
      dispatch(resetVerifyAddress());
    },
    setGlobalErrorAction: (payload) => {
      dispatch(setGlobalError(payload));
    },
    hideErrorAction: (payload) => {
      dispatch(hideError(payload));
    },
    setModalErrorAction: (payload) => {
      dispatch(setModalError(payload));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    addressList: getAddressListState(state),
    isFetching: getAddressListFetchingState(state),
    showUpdatedNotification: showUpdatedNotificationState(state),
    showUpdatedNotificationOnModal: showUpdatedNotificationOnModalState(state),
    deleteModalMountedState: deleteModalOpenState(state),
    verificationResult: getVerificationResult(state),
    isInternationalPhoneNumberEnabled: getIsInternationalPhoneNumber(state),
    newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
    isErrorModalVisibleState: getErrorModalVisibleState(state),
  };
};

const withReducer = withDynamicReducer([
  { key: 'AddressBookReducer', reducer: AddressBookReducer },
  { key: 'AddEditAddressReducer', reducer: AddEditAddressReducer },
  { key: 'GlobalErrorComponent', reducer: GlobalErrorComponentReducer },
]);
const withSaga = withDynamicSaga([
  { key: 'addressBookSaga', saga: AddressBookSaga },
  { key: 'addEditAddressSaga', saga: AddEditAddressSaga },
  { key: 'deleteAddressSaga', saga: DeleteAddressSaga },
  { key: 'setDefaultShippingAddressSaga', saga: SetDefaultShippingAddressSaga },
]);
export default compose(
  withReducer,
  withSaga,
  connect(mapStateToProps, mapDispatchToProps)
)(AddressBookContainer);
